import Market from '@/creditflowresearch/domain/Market';
import { MarketName } from '@/creditflowresearch/domain/Market/types/MarketType';
import { IRegionFilter } from '@/creditflowresearch/application/PageFilters/hooks/create/useCreateRegionFilters';
import { formatMarketDisplayName } from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles/helpers';

export const getLocationDisplayName = (
  isCorporateContext: boolean,
  markets: string | string[] | undefined,
  selectedRegions: IRegionFilter[],
): string => {
  if (isCorporateContext && markets) {
    return Market.getDisplayNames(markets).map(formatMarketDisplayName).join(', ');
  }
  return selectedRegions.map(({ shortDisplayName }) => shortDisplayName).join(', ');
};

export const getProductName = ({
  companyViewId,
  companyName,
  isSectorPage,
  sectorPageTitleName,
  isIndustryPage,
  industryPageTitleName,
  markets,
  marketDataName,
}: {
  companyViewId: string | string[] | undefined,
  companyName: string,
  isSectorPage: string | string[] | undefined,
  sectorPageTitleName: string,
  isIndustryPage: string | string[] | undefined,
  industryPageTitleName: string,
  markets: string | string[] | undefined,
  marketDataName: string | undefined,
}): string => {
  if (companyViewId) {
    return companyName;
  }
  if (isSectorPage) {
    return sectorPageTitleName;
  }
  if (isIndustryPage) {
    return industryPageTitleName;
  }
  const marketsArray = Array.isArray(markets) ? markets : markets?.split(',') ?? [];
  if (marketsArray.some((market) => Market.isOfType(market, MarketName.EMERGING_MARKET))) {
    return '';
  }
  return marketDataName || '';
};

export const getLabel = ({
  isOneFilterSelected,
  isSubscribed,
  shortDisplayName,
  name,
  articleType,
  isCompanyPage,
  isCorporateContext,
}: {
  isOneFilterSelected: boolean,
  isSubscribed: boolean,
  shortDisplayName: string,
  name: string,
  articleType: string,
  isCompanyPage: boolean,
  isCorporateContext: boolean,
}) => {
  if (isCompanyPage) {
    return `Subscribe${ isSubscribed ? 'd' : '' } to ${ name } 
          Commentary & Deal Flow Email Alerts`;
  }

  if (!isOneFilterSelected) {
    const locationText = isCorporateContext ? 'product/market' : 'product/region';
    return `Select 1 credit ${ locationText } to manage email alerts`;
  }

  return `Subscribe${ isSubscribed ? 'd' : '' } to ${ shortDisplayName }${ name ? ` ${ name }` : '' } 
          ${ articleType } Email Alerts`;
};
